import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { homePathFor } from "../common/enum/Role";

// Renders child routes only for the given roles; others go to their home page.
export const RoleRoute: React.FC<{ roles: string[] }> = ({ roles }) => {
  const { user } = useAuth();
  if (!user?.role || !roles.includes(user.role)) {
    return <Navigate to={homePathFor(user?.role)} replace />;
  }
  return <Outlet />;
};

export const HomeRedirect: React.FC = () => {
  const { user } = useAuth();
  return <Navigate to={homePathFor(user?.role)} replace />;
};
